import React, {useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {EvaArrowIosBackFill} from './icons/BackButton'
import DatePicker from 'react-multi-date-picker'
import DatePanel from 'react-multi-date-picker/plugins/date_panel'
import MarketingService from '../../../api/MarketingService'
import {toast} from 'react-toastify'
import ReactDatePicker from 'react-datepicker'
export default function EditCustomizedDate() {
  const location = useLocation()
  const {description, route, title, ids, message, reception_type,id} = location.state || {}
  const navigate = useNavigate()
  const [date, setDate] = useState([])
  const [scheduledInterval, setScheduledInterval] = useState('')
  const [errors, setErrors] = useState({})
  const [selectedTime, setSelectedTime] = useState(null)
  const [selectedTimeError, setSelectedTimeError] = useState(false)

  const handleScheduledIntervalChange = (e) => {
    setScheduledInterval(e.target.value)
    if (errors.scheduledInterval) {
      setErrors((prev) => ({...prev, scheduledInterval: ''}))
    }
  }

  const handleNextClick = (e) => {
    e.preventDefault()
    let validationErrors = {}
    if (!scheduledInterval) {
      validationErrors.scheduledInterval = 'Scheduled interval is required'
    }
    if (date.length === 0) {
      validationErrors.date = 'At least one date must be selected'
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors)
      return
    }
    let formattedDates = date.map((d) => d.format('YYYY-MM-DD'))
    let data = {
      id,
      description,
      route,
      title,
      ids,
      message,
      reception_type,
      date: formattedDates,
      time: selectedTime
          ? selectedTime.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', hour12: false})
          : '00:00',
    }
    MarketingService.updateCampaign(data).then(
      (res) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, {theme: 'dark'})
          navigate('/campaign/edit-confirmation', {
            state: {
              startDate: formattedDates[0],
              endDate: formattedDates[formattedDates.length - 1],
              time: selectedTime
              ? selectedTime.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', hour12: false})
              : '00:00',
            },
          })
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }
  const handleSelectedTimeChange = (date) => {
    if (date) {
      setSelectedTime(date)
      setSelectedTimeError(false)
    } else {
      setSelectedTime(null)
      setSelectedTimeError(true)
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          cursor: 'pointer',
          alignContent: 'center',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
        onClick={() => navigate(-1)}
      >
        <div style={{padding: 5, backgroundColor: 'white', borderRadius: 100, marginRight: 5}}>
          <EvaArrowIosBackFill />
        </div>
        <p style={{fontSize: 14, fontWeight: 'bold', margin: 0}}>Back</p>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          paddingRight: 30,
          paddingLeft: 50,
          marginTop: 20,
        }}
      >
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            1
          </p>
          <p style={{fontSize: 14, marginLeft: 5, color: '#B0B0B0'}}>Update Campaign</p>
        </div>

        <hr style={{width: 170, marginLeft: 5, marginRight: 5, color: '#B0B0B0'}} />
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            2
          </p>
          <p style={{fontSize: 14, marginLeft: 5}}>Update Recipients</p>
        </div>

        <hr style={{width: 170, marginLeft: 5, marginRight: 5}} />
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#2ABD84',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            3
          </p>
          <p style={{fontSize: 14, marginLeft: 5, color: '#2ABD84'}}>Update Campaign Periods</p>
        </div>

        <hr style={{width: 170, marginLeft: 5, marginRight: 5, color: '#2ABD84'}} />
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            4
          </p>
          <p style={{fontSize: 14, marginLeft: 5}}>Confirm</p>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'row',
          marginRight: 30,
          marginLeft: 30,
          marginTop: 10,
          backgroundColor: 'white',
          paddingRight: 30,
          paddingLeft: 30,
          paddingTop: 60,
          paddingBottom: 60,
          borderRadius: 10,
        }}
      >
        <div className='col-lg-6 col-12 mb-10'>
          <div style={{padding: 20}}>
            <h2 style={{fontSize: 36, color: '#736F6F', marginBottom: 20}}>Customized Date</h2>
            <p style={{fontSize: 16, color: '#898484'}}>
              Should you want to select specific dates on which you want your messages passed to
              your clients, Customized Date will help you achieve this.
            </p>
            <p style={{fontSize: 16, color: '#898484', textAlign: 'justify'}}>
              <strong>Select</strong> the days you want to carry out the campaign.
            </p>
          </div>
        </div>
        <div className='col-lg-6 col-12'>
          <form onSubmit={handleNextClick}>
            <div className='form-group mb-3'>
              <label style={{color: '#4A4747', fontSize: 16}}>Scheduled Interval</label>
              <select
                className='form-control form-select'
                value={scheduledInterval}
                onChange={handleScheduledIntervalChange}
              >
                <option value={''}>Select Scheduled Interval</option>
                {[1, 2, 3, 4, 5, 6, 7].map((e, index) => (
                  <option value={e} key={index}>
                    {e}
                  </option>
                ))}
              </select>
              {errors.scheduledInterval && (
                <p style={{color: 'red', fontSize: 14}}>{errors.scheduledInterval}</p>
              )}
            </div>
            <div className='form-group mb-3'>
              <label style={{color: '#4A4747', fontSize: 16}}>Select Dates</label>
              <DatePicker
                format='YYYY-MM-DD'
                dateSeparator=' & '
                plugins={[<DatePanel />]}
                style={{width: 600, height: 40}}
                className='form-control'
                multiple
                // range
                value={date}
                onChange={setDate}
                minDate={new Date()}
              />
              {errors.date && <p style={{color: 'red', fontSize: 14}}>{errors.date}</p>}
            </div>

            <div className='form-group mb-3'>
              <label style={{color: '#4A4747', fontSize: 16}}>Select Time</label>
              <ReactDatePicker
                className={`form-control ${selectedTimeError ? 'is-invalid' : ''}`}
                selected={selectedTime}
                onChange={handleSelectedTimeChange}
                placeholderText='Select Time'
                showTimeSelectOnly
                showTimeSelect
                timeFormat='HH:mm'
                timeIntervals={60}
                dateFormat='HH:mm'
              />
              {selectedTimeError && <div className='invalid-feedback'>Time is required.</div>}
            </div>

            <div className='d-flex justify-content-end mt-3'>
              <button
                type='submit'
                className='btn'
                style={{
                  padding: '10px 70px',
                  borderRadius: 20,
                  backgroundColor: '#00B649',
                  color: 'white',
                  marginTop: 50,
                }}
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
